import React, { useMemo, useState } from "react";
import { format } from "date-fns";
import Table from "../../../components/ui/table/Table";
import { downloadLoader } from "../../../assetData/loaders";

const CorporateActionConfig = ({ tableData, buttonConfig, loading }) => {
  const [loadingRows, setLoadingRows] = useState({});

  const handleReload = async (date, rowId) => {
    setLoadingRows((prev) => ({ ...prev, [rowId]: true }));

    const res = await buttonConfig?.handleReload(date);
    if (res) {
      setLoadingRows((prev) => {
        const { [rowId]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "date",
        header: "DATE",
        size: 130,
        Cell: ({ row }) => format(new Date(row.original.date), "dd MMM yyyy"),
        sortingFn: "datetime",
      },
      {
        accessorKey: "day",
        header: "WEEKDAY",
        size: 120,
      },
      {
        accessorKey: "file_name",
        header: "FILE NAME",
        size: 150,
      },

      {
        accessorKey: "ip_cnt",
        header: "Records Received",
        size: 180,
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },

      {
        accessorKey: "op_cnt",
        header: "Records Inserted",
        size: 180,
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },

      {
        accessorKey: "status",
        header: "STATUS",
        size: 120,
      },
      {
        id: "reload",
        header: "ACTIONS",
        size: 100,

        Cell: ({ row }) => {
          const isLoading = !!loadingRows[row.id];
          const isSuccess = row.original.status === "Success";
          const disabled = isLoading || isSuccess;

          return (
            <button
              className={`flex h-[25px] w-[70px] items-center justify-center rounded bg-pri-clr-orange px-2 py-1 text-white transition hover:brightness-95 ${
                disabled ? "opacity-[75%]" : ""
              }`}
              onClick={() => handleReload(row.original.date, row.id)}
              disabled={disabled}
            >
              {isLoading ? (
                <img
                  src={downloadLoader}
                  className="px-2 py-1 text-white brightness-200"
                  alt="loader"
                />
              ) : (
                "RELOAD"
              )}
            </button>
          );
        },
      },
    ],
    [loadingRows],
  );

  return (
    <Table
      pageName={"MFNAV"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
      tableData={tableData}
      columns={columns}
      loading={loading}
    />
  );
};

export default CorporateActionConfig;
